import type { AppointmentForm } from '@devexpress/dx-react-scheduler-material-ui';
import React from 'react';

import Dropdown from '@components/Dropdown/Dropdown';

/**
 * VITALL-styled select component for the routine form
 */
const Select = ({ ...props }: AppointmentForm.SelectProps) => {
  const { onValueChange, availableOptions, value } = props;
  return (
    <Dropdown onChange={onValueChange} value={value.toString()} width="auto">
      {availableOptions?.map((availableOption) => (
        <option key={availableOption.id} value={availableOption.id}>
          {availableOption.text}
        </option>
      ))}
    </Dropdown>
  );
};

export default Select;
